var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 16C1 7.71573 7.71573 1 16 1C24.2843 1 31 7.71573 31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16Z",
    fill: "#D26060",
    stroke: "#D26060",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6894 9.3212C22.2753 8.90709 21.6064 8.90709 21.1923 9.3212L16 14.5028L10.8077 9.31058C10.3936 8.89647 9.72469 8.89647 9.31058 9.31058C8.89647 9.72469 8.89647 10.3936 9.31058 10.8077L14.5028 16L9.31058 21.1923C8.89647 21.6064 8.89647 22.2753 9.31058 22.6894C9.72469 23.1035 10.3936 23.1035 10.8077 22.6894L16 17.4972L21.1923 22.6894C21.6064 23.1035 22.2753 23.1035 22.6894 22.6894C23.1035 22.2753 23.1035 21.6064 22.6894 21.1923L17.4972 16L22.6894 10.8077C23.0929 10.4042 23.0929 9.72469 22.6894 9.3212Z",
    fill: "#E8E9EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.1c75f822.svg";
export { ForwardRef as ReactComponent };